import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface Props {
    children: React.ReactNode;
}

const ProtectedRoute: React.FC<Props> = ({ children }) => {
    const { agent, loading, isAuthenticated } = useAuth();
    const location = useLocation();

    if (loading) return null;

    // لاگین نیست
    if (!isAuthenticated || !agent) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    const isApproved =
        agent.is_approved === true ||
        agent.request_status === 'approved';

    // ✅ تا وقتی تایید نشده، فقط onboarding
    if (!isApproved) {
        if (location.pathname !== '/onboarding') {
            return <Navigate to="/onboarding" replace />;
        }
    }

    // ✅ (اختیاری) اگر قرارداد داری: تا قبول نشده فقط contract
    // اگر هنوز قرارداد نداری، این بلوک رو کامنت نگه دار.
    if (isApproved && agent.contract_accepted === false) {
        if (location.pathname !== '/contract') {
            return <Navigate to="/contract" replace />;
        }
    }

    return <>{children}</>;
};

export default ProtectedRoute;
